import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { useQueryLoginUserContext } from 'src/features/tanStackQuery/commonQueries/useQueryLoginUserContext'
import { GlossaryJobStatus } from '../types'
import { glossaryQueryKeys } from './queryKeys'
import { useQueryGlossaryJobsLatestStatus } from './useQueryGlossaryJobsLatestStatus'

const POLLING_INTERVAL = 5000

/**
 * 用語集ジョブのポーリングを管理するhook。
 * 自分がアップロードしたジョブがUPLOADING中の場合のみ5秒ごとにポーリングし、
 * COMPLETED/FAILEDになったらsnackbar通知＋一覧更新。
 */
export const useGlossaryJobPolling = () => {
  const queryClient = useQueryClient()
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar()

  const { data: loginUser } = useQueryLoginUserContext()
  const { data, refetch } = useQueryGlossaryJobsLatestStatus(true)

  const status = data?.status ?? null
  const isMyJob =
    data?.uploaderRumpCustomerMemberId === loginUser?.rumpCustomerMemberId
  const isMyUploading = status === GlossaryJobStatus.Uploading && isMyJob

  useEffect(() => {
    if (!isMyUploading) return

    const interval = setInterval(async () => {
      const { data: result } = await refetch()

      if (result?.status === GlossaryJobStatus.Completed) {
        showSuccessSnackbar('用語集の登録が完了しました')
        queryClient.invalidateQueries({
          queryKey: glossaryQueryKeys.glossaryJobs.all,
        })
      } else if (result?.status === GlossaryJobStatus.Failed) {
        showErrorSnackbar(
          '用語集の登録に失敗しました。データ処理状況をご確認ください。',
        )
      }
    }, POLLING_INTERVAL)

    return () => clearInterval(interval)
  }, [
    isMyUploading,
    queryClient,
    showSuccessSnackbar,
    showErrorSnackbar,
    refetch,
  ])
}
